// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap__IE2Yw","img":"index_img__+0tiF","closeBtn":"index_closeBtn__oJabR"};